import { BasePayloadMapper } from '@ps/utils';

import { CurrencyUpdatePayload } from '../../models/currency.model';
import { UpdateCurrencyPayloadDto } from '../dtos/currency.dto';

export class CurrencyPayloadMapper extends BasePayloadMapper<
  CurrencyUpdatePayload,
  UpdateCurrencyPayloadDto
> {
  public toPayload(model: CurrencyUpdatePayload): UpdateCurrencyPayloadDto {
    return {
      fx: model.fx,
      CRRate: model.crRate,
      symbol: model.symbol,
    };
  }
}
